import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useApp } from '@/hooks/useApp'
import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Recap } from '../../../containers/chaloupka/Recap'
import { WithOffer } from '../../../containers/hoc/WithOffer'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { MeetingRecordForm } from '../../../containers/MeetingRecordForm'
import { StepsContent } from '../../../context/StepsContext'
import { useGetMeetingRecord } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { meetingRecordContext } from '../../carkulka/wizard/5'
import { CompletedPage } from './completed'

const Step5Component = () => {
  const { product, setProduct } = useApp()
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId, isLoadingData } = useContext(
    insuranceParamsContext,
  )
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  // get formulare
  const { isLoading, isFetching, data, refetch } = useGetMeetingRecord(
    insuranceParamsId!,
    { enabled: !!insuranceParamsId, gcTime: 0 },
  )

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  useEffect(() => {
    if (
      !isLoadingData &&
      insuranceParams &&
      (insuranceParams.generalParams?.lastWizardStep ?? 1) < 5
    )
      navigate('/chaloupka/wizard/too-far', { replace: true })

    if (
      !isLoading &&
      insuranceParams &&
      !insuranceParams.generalParams.selectedOfferId
    )
      navigate(`/chaloupka/wizard/3/${insuranceParamsId}`, { replace: true })
  }, [isLoadingData, insuranceParams])

  return (
    <Section>
      <Container>
        <meetingRecordContext.Provider
          value={{
            isLoading: isFetching || isLoading,
            refetch: refetch,
            meetingRecord: data?.data,
          }}
        >
          {(isLoadingData || isLoading) && <Loading large={true} />}

          {(!insuranceParamsId || insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType) &&
            !isContracted &&
            !!insuranceParams &&
            !isLoadingData &&
            !isLoading && (
              <StepsContent step={5}>
                <Steps icon="house" />

                <InsuranceInfo />

                <MainContent>
                  <Recap />

                  <MeetingRecordForm />
                </MainContent>
              </StepsContent>
            )}

          {isContracted && !!insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType &&
            <CompletedPage />
          }
        </meetingRecordContext.Provider>

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step5 = WithOffer(Step5Component)
